interface MyNavigator extends Navigator {
  app?: any;
}
declare const navigator: MyNavigator;

export function BackButton() {
  document.addEventListener(
    'backbutton',
    (e) => {
      const path = window.location.pathname;
      const pathMatches = (pattern) =>
        path.startsWith(`${pattern}?`) || path === pattern;

      if (pathMatches('/')) {
        e.preventDefault();
        navigator.app.exitApp();
      } else if (['schedule', 'messages', 'action'].some(pathMatches)) {
        window.location.pathname = '/';
        navigator.app.clearHistory();
      } else {
        navigator.app.backHistory();
      }
    },
    false,
  );
}
